<template>
  <div class="sidenav" style="margin-left:-15px; margin-top:-20px;">
    <h1 style="padding: 28px 8px 18px 20px; background: white; margin: 0;">
      Menu
    </h1>
    <div class="box">
      <router-link
        :to="{ name: 'provider' }"
        :class="{ highlight: this.current == 'provider' }"
        >General Info</router-link
      >
      <router-link
        :to="{ name: 'general-info' }"
        :class="{ highlight: this.current == 'general-info' }"
        >Relevancy Info</router-link
      >
      <router-link
        :to="{ name: 'key-statistics' }"
        :class="{ highlight: this.current == 'key-statistics' }"
        >Key Statistics</router-link
      >
      <router-link
        :to="{ name: 'contact-page' }"
        :class="{ highlight: this.current == 'contact-page' }"
        >Contact</router-link
      >
      <router-link
        :to="{ name: 'locale-page' }"
        :class="{ highlight: this.current == 'locale-page' }"
        >Locale</router-link
      >
      <router-link
        :to="{ name: 'deal-page' }"
        :class="{ highlight: this.current == 'deal-page' }"
        >Deals</router-link
      >
      <router-link
        tag="a"
        :to="{ name: 'submit' }"
        :class="{ highlight: this.current == 'submit' }"
        >Overview</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapGetters({
      current: "current"
    })
  }
};
</script>

<style>
.sidenav {
  padding: 0px;
  background: #efefef;
  border-right: 1px solid black;
}
.box {
  border-top: 1px solid black;
}

.sidenav a {
  padding: 8px 8px 8px 20px;
  text-decoration: none;
  font-size: 20px;
  display: block;
  background-color: white;
  color: black;
  border-bottom: 1px solid black;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.sidenav a:hover {
  background: lightgrey;
}
.highlight {
  background: #2d3f50 !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/elements/sideNav.vue